import { useState, useEffect } from "react";
import { IoSaveOutline } from "react-icons/io5";
import { FaCircleNotch } from "react-icons/fa";

import WysiwygEditor from "../../../../../components/common/WysiwygEditor";
import Toaster from "./../../../../../components/common/Toaster";

import accountService from "../../../../../services/accountService";
import DOMPurify from "dompurify";

const NotesForm = ({ data, isLoading, setData, setLoading, setShow }) => {
  const [text, setText] = useState(null);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const hasText = !!text.replace(/(<([^>]+)>)/gi, "").length;
      const notes = hasText ? text : null;

      const item = { ...data };
      item["account_id"] = data.id;
      item["notes"] = notes;

      await accountService.saveNotesAsync(item);

      setData(item);

      Toaster.Success("Notes Saved Successfully!");

      setLoading(false);
      setShow(false);
    } catch (ex) {
      console.log(ex);
      Toaster.Error("Something went wrong.");
      setLoading(false);
    }
  };

  const handleChange = (item) => {
    const clean = DOMPurify.sanitize(item, {
      ALLOWED_TAGS: [
        "p",
        "b",
        "i",
        "em",
        "strong",
        "s",
        "a",
        "ul",
        "ol",
        "li",
        "br",
      ],
    });

    setText(clean);
  };

  useEffect(() => {
    if (data) {
      setText(data.notes);
    }
  }, [data]);

  return (
    <div className="p-8">
      <div className="grid grid-cols-2">
        <div className="col-span-2 h-64">
          <WysiwygEditor
            value={text}
            onChange={handleChange}
            className="h-52"
            placeholder="Say something..."
          />
        </div>
      </div>
      <div className="grid grid-cols-2 mt-8">
        <div className="col-span-2">
          <button
            type="button"
            className="button float-right button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={() => handleSubmit()}
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotesForm;
